// extracted by mini-css-extract-plugin
export default {"container":"pause-button_container__j8O7-","pause":"pause-button_pause__XBrLf","play":"pause-button_play__WtW0Y"};